<div class="d-flex flex-column gap-2">
  <div class="d-flex align-items-center" [style.gap.rem]="0.75">
    <div class="d-flex align-items-center gap-2">
      <app-user-profile-badge [initials]="comment.author.initials" [textColor]="comment.author.profileColour" />
      <div class="label-md">{{ comment.author.fullName }}</div>
    </div>
    <div class="label-md pt-1">•</div>
    <div class="date-text">{{ comment.formattedDate }}</div>
  </div>
  <div class="comment-text" [innerHTML]="comment.comment"></div>
</div>
